import { createReducer, on } from '@ngrx/store';
import * as fromDeclineProtection from '@additional-services/store/actions/decline.protection.action';
import { StateSlice } from '@core/helpers/state-slice';

export type DeclineProtectionState = StateSlice<boolean>;

export const initialState: DeclineProtectionState = {
  data: false,
  loaded: false,
  loading: false,
  error: null,
};

const declineProtectionReducer = createReducer(
  initialState,
  on(fromDeclineProtection.declineProtection, (state) => {
    return {
      ...state,
      data: true,
      loading: false,
      loaded: true,
    };
  }),
  on(fromDeclineProtection.resetDeclineProtection, () => {
    return {
      ...initialState,
    };
  })
);

export function reducer(
  state: DeclineProtectionState | undefined,
  action: fromDeclineProtection.DeclineProtectionActions
) {
  return declineProtectionReducer(state, action);
}
